/*
  D'Avila — esconde ",00" nos precos exibidos.
  Mantem centavos quando > 0 (ex: R$ 396,04 nao muda).
  Roda no load e em mutations (variant change, cart AJAX, etc).
*/
(function () {
  'use strict';

  // Seletores de elementos que contem precos no tema
  var PRICE_SELECTORS = [
    '.money',
    '.price-item',
    '.price__regular .price-item',
    '.price__sale .price-item',
    '.davila-price-value',
    '.davila-price-pix-value',
    '.davila-price-original-cupom',
    '.davila-card__price',
    '.davila-card__price-compare',
    '.davila-cart__total-value',
    '.davila-cart__subtotal-value',
    '.davila-cart-item__price',
    '.davila-cart-item__price-compare',
    '.davila-cart-item__unit-price',
    '.cart__totals .totals__total-value',
    '.totals__subtotal-value'
  ].join(', ');

  // Regex: pega ",00" no fim OU antes de espaco/moeda/final de string
  // Ex: "R$ 399,00" -> "R$ 399"; "R$ 1.234,00 BRL" -> "R$ 1.234 BRL"
  var CENTS_RE = /(\d),00(?=\D|$)/g;

  function scrub(el) {
    if (!el) return;
    // Percorre apenas nos de texto pra nao quebrar html interno
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue && node.nodeValue.indexOf(',00') !== -1) {
        var novo = node.nodeValue.replace(CENTS_RE, '$1');
        if (novo !== node.nodeValue) node.nodeValue = novo;
      }
    }
  }

  function scrubAll(root) {
    var scope = root || document;
    var els = scope.querySelectorAll(PRICE_SELECTORS);
    for (var i = 0; i < els.length; i++) scrub(els[i]);
  }

  // Rodada inicial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scrubAll(); });
  } else {
    scrubAll();
  }

  // Reage a mudancas no DOM (variant switch, cart update, etc)
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'childList') {
        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (node.nodeType === 1) scrubAll(node);
        }
      } else if (m.type === 'characterData' && m.target.parentElement) {
        // Se o texto de um preco existente mudou, refaz o scrub no elemento pai
        var parent = m.target.parentElement;
        if (parent.closest && parent.closest(PRICE_SELECTORS)) {
          scrub(parent);
        }
      }
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();
